namespace Matrix.Workflow {
    export interface WorkflowMapForm {
        TestCode: Serenity.LookupEditor;
        ResultCode: TestResultCodeEditor;
        FailThreshold: Serenity.IntegerEditor;
        WorkflowCode: FormatLookupEditor;
        HelpText: Serenity.TextAreaEditor;
        CustomFilter: CodeEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class WorkflowMapForm extends Serenity.PrefixedContext {
        static formKey = 'Workflow.WorkflowMap';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WorkflowMapForm.init)  {
                WorkflowMapForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = TestResultCodeEditor;
                var w2 = s.IntegerEditor;
                var w3 = FormatLookupEditor;
                var w4 = s.TextAreaEditor;
                var w5 = CodeEditor;
                var w6 = StaticTextBlock;
                var w7 = ReadOnlyDateTime;

                Q.initFormType(WorkflowMapForm, [
                    'TestCode', w0,
                    'ResultCode', w1,
                    'FailThreshold', w2,
                    'WorkflowCode', w3,
                    'HelpText', w4,
                    'CustomFilter', w5,
                    'CreatedBy', w6,
                    'CreatedWhen', w7,
                    'UpdatedBy', w6,
                    'UpdatedWhen', w7,
                    'Version', w6
                ]);
            }
        }
    }
}
